import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { LevelsResultsResponse } from '../../../models/levels/responses/api-levels-results-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiLevelsService {

  constructor(private apiService: ApiService) { }

  getLevels(page: number, resultCount: number): Promise<LevelsResultsResponse> {
    return new Promise<LevelsResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount };
      this.apiService.launchAdminApiRequestPost(apiUrls.levelsGetLevelsUrl, body, LevelsResultsResponse).then(
        (data: LevelsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addLevel(level: number, nextLevelExperienceRequired: number, nextLevelReward: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { level, next_level_experience_required: nextLevelExperienceRequired, next_level_reward: nextLevelReward };
      this.apiService.launchAdminApiRequestPost(apiUrls.levelsAddLevelUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editLevel(levelId: number, level: number, nextLevelExperienceRequired: number, nextLevelReward: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { level_id: levelId, level, next_level_experience_required: nextLevelExperienceRequired, next_level_reward: nextLevelReward };
      this.apiService.launchAdminApiRequestPost(apiUrls.levelsEditLevelUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteLevel(levelId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.levelsDeleteLevelUrl, { level_id: levelId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }
}
